import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteSummaryId',
  props: {
    row: null
  },
  setup(__props: any) {

const props = __props as {
  row: QuoteSummary
};



const showNewIndicator = computed(() => {
  const { seenByClient, expirationDatetime } = props.row
  const hasBeenSeen = !!seenByClient
  if (hasBeenSeen) {
    return false
  }

  if (!expirationDatetime) {
    return false
  }
  return !isExpiredV2(expirationDatetime)
})

return { __sfc: true,props, showNewIndicator }
}

})